import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ConsentSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ConsentSVG;
